/**
 * @generated SignedSource<<cb01606368c166c52aeb65c4ef9d6909>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginProviderEnum = "AZURE_SINGLE_TENANT" | "FACEBOOK" | "GITHUB" | "GOOGLE_MULTI_TENANT" | "INSTAGRAM" | "LINKEDIN" | "OAUTH2_GENERIC" | "PASSWORD" | "SITETOKEN";
export type LoginInput = {
  clientMutationId?: string | null | undefined;
  credentials?: PasswordProviderResponseInput | null | undefined;
  identity?: string | null | undefined;
  oauthResponse?: OAuthProviderResponseInput | null | undefined;
  provider: LoginProviderEnum;
};
export type PasswordProviderResponseInput = {
  password: string;
  username: string;
};
export type OAuthProviderResponseInput = {
  code: string;
  code_verifier?: string | null | undefined;
  state?: string | null | undefined;
};
export type Auth_LoginWithProvider_Mutation$variables = {
  input: LoginInput;
};
export type Auth_LoginWithProvider_Mutation$data = {
  readonly login: {
    readonly authToken: string | null | undefined;
    readonly authTokenExpiration: string | null | undefined;
    readonly refreshToken: string | null | undefined;
    readonly refreshTokenExpiration: string | null | undefined;
    readonly user: {
      readonly avatar: {
        readonly url: string | null | undefined;
      } | null | undefined;
      readonly capabilities: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly description: string | null | undefined;
      readonly email: string | null | undefined;
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly meta: {
        readonly jobRole: string | null | undefined;
        readonly profileArticleLinks: ReadonlyArray<{
          readonly iconName: string | null | undefined;
          readonly name: string | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly profileImage: {
          readonly id: string;
          readonly mediaDetails: {
            readonly sizes: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly sourceUrl: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly mediaItemUrl: string | null | undefined;
        } | null | undefined;
        readonly profileSocialLinks: ReadonlyArray<{
          readonly name: string | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly name: string | null | undefined;
      readonly nicename: string | null | undefined;
      readonly nickname: string | null | undefined;
      readonly role: string | null | undefined;
      readonly slug: string | null | undefined;
      readonly username: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Auth_LoginWithProvider_Mutation = {
  response: Auth_LoginWithProvider_Mutation$data;
  variables: Auth_LoginWithProvider_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LoginPayload",
    "kind": "LinkedField",
    "name": "login",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authTokenExpiration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshTokenExpiration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nicename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "size",
                "value": 10
              }
            ],
            "concreteType": "Avatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": "avatar(size:10)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User_Meta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobRole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "profileImage",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaItemUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaDetails",
                    "kind": "LinkedField",
                    "name": "mediaDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourceUrl",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User_Meta_profileSocialLinks",
                "kind": "LinkedField",
                "name": "profileSocialLinks",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User_Meta_profileArticleLinks",
                "kind": "LinkedField",
                "name": "profileArticleLinks",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconName",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nickname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capabilities",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Auth_LoginWithProvider_Mutation",
    "selections": (v4/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Auth_LoginWithProvider_Mutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "37693a1832b15a99f04d0f9ccc48b5d5",
    "id": null,
    "metadata": {},
    "name": "Auth_LoginWithProvider_Mutation",
    "operationKind": "mutation",
    "text": "mutation Auth_LoginWithProvider_Mutation(\n  $input: LoginInput!\n) {\n  login(input: $input) {\n    authToken\n    authTokenExpiration\n    refreshToken\n    refreshTokenExpiration\n    user {\n      id\n      slug\n      role\n      username\n      name\n      nicename\n      avatar(size: 10) {\n        url\n      }\n      meta {\n        jobRole\n        profileImage {\n          id\n          mediaItemUrl\n          mediaDetails {\n            sizes {\n              sourceUrl\n              name\n            }\n          }\n        }\n        profileSocialLinks {\n          name\n          url\n        }\n        profileArticleLinks {\n          name\n          iconName\n          url\n        }\n      }\n      nickname\n      firstName\n      lastName\n      description\n      email\n      capabilities\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1cce448f09dcff91c92da7b31387919f";

export default node;
